module.exports = __webpack_public_path__ + "static/media/Sailor.e302b924.jpg";